import React, { useState } from "react";
import { useSelector } from "react-redux";
import style from "./measurementSidebar.module.scss";
import { ZoomPhoto } from "../Photos";
import noWoundImage from "../../../../static/images/wound_image_not_process.png";
import { StatusBanner } from "../../../secondary";

export const MeasurementSidebar = () => {
  const [woundImageLoading, setWoundImageLoading] = useState(true);

  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };

  return (
    <div className="col-4">
      {measurementData?.status === "success" && !measurementData?.measurementRetry && <StatusBanner status="info" message={"Image measured successfully"} layout="inline" />}
      <div className={`${style.patient_wound} mt-2`}>
        <ZoomPhoto
          image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL}
          loading={woundImageLoading}
          setLoading={setWoundImageLoading}
          showBottomBtn={false}
          classes={{
            outerClass: undefined,
            innerClass: "position-relative w-100",
            shimmerClass: style.image_skeleton,
          }}
          showTopBtn={assessmentDetail?.isWoundWithoutPhoto === 0}
          fallbackImage={noWoundImage}
        />
      </div>
    </div>
  );
};
